"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExamplesFromSchema = exports.normalizeProducesOrConsumes = exports.getConsumes = exports.getProduces = exports.getSecurities = void 0;
const json_1 = require("@stoplight/json");
const pickBy = require("lodash.pickby");
const guards_1 = require("../guards");
const guards_2 = require("./guards");
function getSecurities(spec, operationSecurity) {
    const globalSecurities = getSecurity(spec.security, spec.securityDefinitions || {});
    const operationSecurities = getSecurity(operationSecurity, spec.securityDefinitions || {});
    const securities = !!operationSecurity ? operationSecurities : globalSecurities;
    return securities.filter(a => a.length);
}
exports.getSecurities = getSecurities;
function getProduces(spec, operation) {
    return getProducesOrConsumes('produces', spec, operation);
}
exports.getProduces = getProduces;
function getConsumes(spec, operation) {
    return getProducesOrConsumes('consumes', spec, operation);
}
exports.getConsumes = getConsumes;
function getSecurity(security, definitions) {
    if (!Array.isArray(security) || !definitions) {
        return [];
    }
    return security.map(sec => {
        if (!(0, json_1.isPlainObject)(sec))
            return [];
        return Object.keys(sec)
            .map(key => {
            const def = definitions[key];
            if ((0, guards_2.isSecurityScheme)(def)) {
                const defCopy = { ...def, key };
                const secKey = sec[key];
                const scopes = Array.isArray(secKey) ? secKey : [];
                if (defCopy.type === 'oauth2' && scopes.length) {
                    defCopy.scopes = pickBy(defCopy.scopes, (_val, s) => scopes.includes(s));
                }
                return defCopy;
            }
            return null;
        })
            .filter(guards_1.isNonNullable);
    });
}
function normalizeProducesOrConsumes(input) {
    if (!Array.isArray(input)) {
        return [];
    }
    return input.flat().filter(guards_1.isString);
}
exports.normalizeProducesOrConsumes = normalizeProducesOrConsumes;
function getProducesOrConsumes(which, spec, operation) {
    return normalizeProducesOrConsumes((operation === null || operation === void 0 ? void 0 : operation[which]) || (spec === null || spec === void 0 ? void 0 : spec[which]));
}
function getExamplesFromSchema(data) {
    if (!(0, json_1.isPlainObject)(data))
        return {};
    return {
        ...((0, json_1.isPlainObject)(data['x-examples']) && { ...data['x-examples'] }),
        ...('example' in data && { default: data.example }),
    };
}
exports.getExamplesFromSchema = getExamplesFromSchema;
//# sourceMappingURL=accessors.js.map